module.exports = __webpack_public_path__ + "img/MLW_II.bdfdaade.svg";